import { compareAppVersion } from './app-version'

// The same module is mirrored in Android assets; business pages never branch by platform.
export function installBluetoothBridge(w) {
  let serial = 0
  const pending = new Map()
  const listeners = new Set()
  const transport = () => w.EelinkBluetoothTransport || (w.webkit && w.webkit.messageHandlers && w.webkit.messageHandlers.bluetooth)
  const supported = () => {
    const query = new URLSearchParams(w.location.search)
    const os = query.get('os')
    let version
    try { version = w.EelinkBridge.getAppVersion() } catch (_) { return false }
    return query.getAll('os').length === 1 && (os === 'ios' || (os === 'android' && query.getAll('new').length === 1 && query.get('new') === '1')) && compareAppVersion(version, 'V1.10') >= 0 && !!transport()
  }
  const originalSupports = w.EelinkBridge.supports
  w.EelinkBridge.supports = name => name === 'bluetooth' ? supported() : originalSupports(name)
  function request(action, payload = {}) {
    if (!(action === 'disconnect' ? transport() : supported())) return Promise.reject(new Error('请更新 App 后使用蓝牙控制'))
    const requestId = 'ble_' + Date.now() + '_' + (++serial)
    return new Promise((resolve, reject) => {
      const timer = w.setTimeout(() => { pending.delete(requestId); reject(new Error('蓝牙请求超时，结果未知，请重新连接并核实状态')) }, action === 'connect' ? 90000 : 30000)
      pending.set(requestId, { resolve, reject, timer })
      try {
        const body = { requestId, action, payload }
        const native = transport()
        native.postMessage(w.EelinkBluetoothTransport ? JSON.stringify(body) : body)
      } catch (error) { w.clearTimeout(timer); pending.delete(requestId); reject(error) }
    })
  }
  w.onEelinkBluetoothResult = result => {
    const entry = result && pending.get(result.requestId)
    if (!entry) return
    w.clearTimeout(entry.timer); pending.delete(result.requestId)
    if (result.ok) entry.resolve(result.data)
    else entry.reject(new Error(result.error || '蓝牙操作失败'))
  }
  w.onEelinkBluetoothEvent = event => {
    listeners.forEach(listener => listener(event))
  }
  w.EelinkBridge.bluetooth = {
    connect: options => request('connect', options),
    write: options => request('write', options),
    disconnect: connectionId => request('disconnect', { connectionId }),
    onEvent: listener => { listeners.add(listener); return () => listeners.delete(listener) }
  }
}

installBluetoothBridge(window)
